import React from 'react';
import MainFilterPanels from '@client/components/search/MainFilterPanels';
import BasicFilters from '@client/feature/activeSubstance/components/Search/Filters/Basic';
import ExtraFilters from '@client/feature/activeSubstance/components/Search/Filters/ExtraFilters';
import { useFilterPanels } from '@client/hooks/useFilterPanels';
import { BASIC_FILTER_KEYS, EXTRA_FILTER_KEYS } from '@client/feature/activeSubstance/config/filterConfigs';
import SearchIcon from '../../../../img/search-icon.svg';
import AddFiltersIcon from '../../../../img/add_filters.svg';
import UpIcon from '../../../../img/collapse-icon-up.svg';

const ExpandIcon = React.memo(({ isActive }) => (
  <img
    src={UpIcon}
    alt="Toggle"
    style={{
      width: '24px',
      height: '24px',
      transition: 'transform 0.3s ease',
      transform: isActive ? 'rotate(0deg)' : 'rotate(180deg)',
    }}
  />
));

const FilterPanels = ({ filters, onFilterChange }) => {
  const { basicCount, extraCount, defaultActiveKeys } = useFilterPanels(
    filters,
    BASIC_FILTER_KEYS,
    EXTRA_FILTER_KEYS
  );

  return (
    <MainFilterPanels
      BasicFiltersComponent={BasicFilters}
      ExtraFiltersComponent={ExtraFilters}
      filters={filters}
      onFilterChange={onFilterChange}
      basicCount={basicCount}
      extraCount={extraCount}
      defaultActiveKeys={defaultActiveKeys}
      ExpandIcon={ExpandIcon}
      icons={{ search: SearchIcon, addFilters: AddFiltersIcon }}
    />
  );
};

export default React.memo(FilterPanels);
